// Staff copy for digital signage: the Signage page and the Designs editor's media source.
// Native review pending (az, ru). Change a phrase in all three languages at once.
import type { Phrase } from '../staffText'

export const signage = {
  // layout/MediaSource.tsx
  'signage.source': { en: 'Source', az: 'Mənbə', ru: 'Источник' },
  'signage.source.playlist': { en: 'Saved playlist', az: 'Saxlanmış pleylist', ru: 'Сохранённый плейлист' },
  'signage.source.own': { en: 'Own items', az: 'Öz elementləri', ru: 'Свои элементы' },
  'signage.source.campaignsOnly': { en: 'Campaigns only', az: 'Yalnız kampaniyalar', ru: 'Только кампании' },
  'signage.playlist': { en: 'Playlist', az: 'Pleylist', ru: 'Плейлист' },
  // layout/render.tsx: a ticker in the editor, before a playlist feeds it
  'signage.tickerSample': { en: 'Ticker', az: 'Qaçan sətir', ru: 'Бегущая строка' },

  // pages/Signage.tsx and its tabs
  'signage.title': { en: 'Signage', az: 'Reklam', ru: 'Реклама' },
  'signage.tab.library': { en: 'Library', az: 'Kitabxana', ru: 'Медиатека' },
  'signage.tab.playlists': { en: 'Playlists', az: 'Pleylistlər', ru: 'Плейлисты' },
  'signage.tab.campaigns': { en: 'Campaigns', az: 'Kampaniyalar', ru: 'Кампании' },
  'signage.upload': { en: 'Upload', az: 'Yüklə', ru: 'Загрузить' },
  'signage.upload.waiting': { en: 'Waiting', az: 'Gözləyir', ru: 'В очереди' },
  'signage.upload.done': { en: 'Uploaded', az: 'Yükləndi', ru: 'Загружено' },
  'signage.uploadFailed': { en: 'Not uploaded.', az: 'Yüklənmədi.', ru: 'Не загружено.' },
  'signage.space': { en: '{used} of {limit} MB', az: '{used} / {limit} MB', ru: '{used} из {limit} МБ' },
  'signage.library.empty': { en: 'No files yet.', az: 'Hələ fayl yoxdur.', ru: 'Файлов пока нет.' },
  'signage.preview': { en: 'Preview', az: 'Önizləmə', ru: 'Предпросмотр' },
  'signage.name': { en: 'Name', az: 'Ad', ru: 'Название' },
  'signage.kind': { en: 'Kind', az: 'Növ', ru: 'Тип' },
  'signage.size': { en: 'MB', az: 'MB', ru: 'МБ' },
  'signage.added': { en: 'Added', az: 'Əlavə edilib', ru: 'Добавлено' },
  'signage.usedBy': { en: 'Used by', az: 'İstifadə olunur', ru: 'Используется' },
  'signage.picture': { en: 'Picture', az: 'Şəkil', ru: 'Картинка' },
  'signage.film': { en: 'Film', az: 'Video', ru: 'Видео' },
  'signage.rename': { en: 'Rename', az: 'Adını dəyiş', ru: 'Переименовать' },
  'signage.deleteAsk': { en: 'Delete?', az: 'Silinsin?', ru: 'Удалить?' },
  'signage.deleted': { en: 'Deleted.', az: 'Silindi.', ru: 'Удалено.' },
  'signage.playlists.empty': { en: 'No playlists yet.', az: 'Hələ pleylist yoxdur.', ru: 'Плейлистов пока нет.' },
  'signage.newPlaylist': { en: 'New playlist', az: 'Yeni pleylist', ru: 'Новый плейлист' },
  'signage.items': { en: 'Items', az: 'Elementlər', ru: 'Элементы' },
  'signage.seconds': { en: 'Seconds', az: 'Saniyə', ru: 'Секунды' },
  'signage.fit': { en: 'Fit', az: 'Yerləşmə', ru: 'Размещение' },
  'signage.fit.fill': { en: 'Fill', az: 'Doldur', ru: 'Заполнить' },
  'signage.fit.fit': { en: 'Fit', az: 'Sığdır', ru: 'Вписать' },
  'signage.fit.centre': { en: 'Centre', az: 'Mərkəz', ru: 'По центру' },
  'signage.chooseFile': { en: 'From the library', az: 'Kitabxanadan', ru: 'Из медиатеки' },
  'signage.ticker': { en: 'Ticker', az: 'Qaçan sətir', ru: 'Бегущая строка' },
  'signage.addLine': { en: 'Add line', az: 'Sətir əlavə et', ru: 'Добавить строку' },
  'signage.problem.name': { en: 'Give it a name.', az: 'Ad verin.', ru: 'Укажите название.' },
  'signage.problem.tooMany': { en: 'At most 50 items.', az: 'Ən çox 50 element.', ru: 'Не больше 50 элементов.' },
  'signage.problem.seconds': { en: '3 to 3600 seconds each.', az: 'Hər biri 3–3600 saniyə.', ru: 'Каждый 3–3600 секунд.' },
  'signage.problem.ticker': { en: 'At most 10 lines.', az: 'Ən çox 10 sətir.', ru: 'Не больше 10 строк.' },
  'signage.problem.playlist': { en: 'Choose a playlist.', az: 'Pleylist seçin.', ru: 'Выберите плейлист.' },
  'signage.problem.dates': { en: 'The end is before the start.', az: 'Son başlanğıcdan əvvəldir.', ru: 'Конец раньше начала.' },
  'signage.problem.hours': { en: 'The hours end before they start.', az: 'Saatlar başlamazdan əvvəl bitir.', ru: 'Время окончания раньше начала.' },
  'signage.problem.branches': { en: 'Choose a branch.', az: 'Filial seçin.', ru: 'Выберите отделение.' },
  'signage.problem.places': { en: 'Choose a place.', az: 'Yer seçin.', ru: 'Выберите место.' },
  'signage.campaigns.empty': { en: 'No campaigns yet.', az: 'Hələ kampaniya yoxdur.', ru: 'Кампаний пока нет.' },
  'signage.newCampaign': { en: 'New campaign', az: 'Yeni kampaniya', ru: 'Новая кампания' },
  'signage.state': { en: 'State', az: 'Vəziyyət', ru: 'Состояние' },
  'signage.state.off': { en: 'Off', az: 'Söndürülüb', ru: 'Выключена' },
  'signage.state.scheduled': { en: 'Scheduled', az: 'Planlaşdırılıb', ru: 'Запланирована' },
  'signage.state.running': { en: 'Running', az: 'Gedir', ru: 'Идёт' },
  'signage.state.ended': { en: 'Ended', az: 'Bitib', ru: 'Завершена' },
  'signage.state.outside': { en: 'Outside its hours', az: 'Saatlarından kənar', ru: 'Вне часов показа' },
  'signage.state.outranked': { en: 'Behind a high one', az: 'Yüksək prioritetlinin arxasında', ru: 'Уступает приоритетной' },
  'signage.state.noSeat': { en: 'No licence seat', az: 'Lisenziya yeri yoxdur', ru: 'Нет места в лицензии' },
  'signage.state.empty': { en: 'Empty playlist', az: 'Pleylist boşdur', ru: 'Пустой плейлист' },
  'signage.problem.past': { en: 'The end date has passed.', az: 'Son tarix keçib.', ru: 'Дата окончания уже прошла.' },
  'signage.hours': { en: 'Hours', az: 'Saatlar', ru: 'Часы' },
  'signage.everyDay': { en: 'Every day', az: 'Hər gün', ru: 'Каждый день' },
  'signage.duplicate': { en: 'Already in the library as “{name}”.', az: 'Kitabxanada artıq var: «{name}».', ru: 'Уже есть в медиатеке: «{name}».' },
  'signage.from': { en: 'From', az: 'Başlanğıc', ru: 'С' },
  'signage.to': { en: 'To', az: 'Son', ru: 'По' },
  'signage.days': { en: 'Days', az: 'Günlər', ru: 'Дни' },
  'signage.allDay': { en: 'All day', az: 'Bütün gün', ru: 'Весь день' },
  'signage.priority': { en: 'Priority', az: 'Prioritet', ru: 'Приоритет' },
  'signage.priority.normal': { en: 'Normal', az: 'Adi', ru: 'Обычный' },
  'signage.priority.high': { en: 'High', az: 'Yüksək', ru: 'Высокий' },
  'signage.on': { en: 'On', az: 'Aktiv', ru: 'Включена' },
  'signage.branches': { en: 'Branches', az: 'Filiallar', ru: 'Отделения' },
  'signage.places': { en: 'Places', az: 'Yerlər', ru: 'Места' },
  'signage.place.board': { en: 'Main display', az: 'Zal ekranı', ru: 'Табло в зале' },
  'signage.place.kioskIdle': { en: 'Kiosk idle screen', az: 'Kioskun gözləmə ekranı', ru: 'Экран ожидания киоска' },
  'signage.place.kioskBanner': { en: 'Kiosk banner', az: 'Kiosk banneri', ru: 'Баннер киоска' },
  'signage.noPlaylistArea': { en: 'No playlist area', az: 'Pleylist sahəsi yoxdur', ru: 'Нет области плейлиста' },
  'signage.now': { en: 'Plays now', az: 'İndi göstərilir', ru: 'Сейчас показывается' },
  'signage.now.at': { en: 'Plays at {time}', az: '{time} vaxtı göstərilir', ru: 'Показывается: {time}' },
  'signage.branch': { en: 'Branch', az: 'Filial', ru: 'Отделение' },
  'signage.now.until': { en: 'until {time}', az: '{time}-dək', ru: 'до {time}' },
  'signage.now.when': { en: 'When', az: 'Nə vaxt', ru: 'Когда' },
  'signage.now.reset': { en: 'Now', az: 'İndi', ru: 'Сейчас' },
  'signage.now.nothing': { en: 'Nothing', az: 'Heç nə', ru: 'Ничего' },
  'signage.now.design': { en: 'The design’s own', az: 'Dizaynın özününkü', ru: 'Из макета' },
  // pages/signagePlaylists.tsx: cards and the editor
  'signage.nItems': { en: '{n} item|{n} items', az: '{n} element', ru: '{n} элемент|{n} элемента|{n} элементов' },
  'signage.inCampaigns': { en: 'In {n} campaign|In {n} campaigns', az: '{n} kampaniyada', ru: 'В {n} кампании|В {n} кампаниях|В {n} кампаниях' },
  'signage.inDesigns': { en: 'In {n} design|In {n} designs', az: '{n} dizaynda', ru: 'В {n} макете|В {n} макетах|В {n} макетах' },
  'signage.notUsed': { en: 'Not used', az: 'İstifadə olunmur', ru: 'Не используется' },
  'signage.secs': { en: '{n}s', az: '{n} san', ru: '{n} с' },
  'signage.toEnd': { en: 'To end', az: 'Sonadək', ru: 'До конца' },
  'signage.play': { en: 'Play', az: 'Oynat', ru: 'Запустить' },
  'signage.item': { en: 'Item', az: 'Element', ru: 'Элемент' },
  'signage.close': { en: 'Close', az: 'Bağla', ru: 'Закрыть' },
  'signage.duration': { en: 'Duration', az: 'Müddət', ru: 'Длительность' },
  'signage.secondsRange': { en: '{min}–{max} s', az: '{min}–{max} san', ru: '{min}–{max} с' },
  'signage.noItems': { en: 'No items', az: 'Element yoxdur', ru: 'Нет элементов' },
  'signage.shape': { en: 'Screen shape', az: 'Ekran forması', ru: 'Форма экрана' },
  // Redesign (Oct 2026): English only.
  'signage.nPlaylists': { en: '{n} playlist|{n} playlists', az: '', ru: '' },
  'signage.nCampaigns': { en: '{n} campaign|{n} campaigns', az: '', ru: '' },
  'signage.dates': { en: 'Dates', az: '', ru: '' },
  'signage.when': { en: 'Days and hours', az: '', ru: '' },
  'signage.andMore': { en: '+{n}', az: '', ru: '' },
  'signage.addBranches': { en: 'Add branches', az: '', ru: '' },
  'signage.findBranch': { en: 'Find a branch', az: '', ru: '' },
  'signage.findFile': { en: 'Find a file', az: '', ru: '' },
  'signage.noMatch': { en: 'No file matches “{q}”.', az: '', ru: '' },
} satisfies Record<string, Phrase>
